import { BaseApiClient } from './BaseAPIClient';
import { ITrack, ITrackLookupResponse } from '@/data/models/track';
import { ResponseModel } from '@/data/models/model';

export class TrackApiClient extends BaseApiClient {
  constructor() {
    super(BaseApiClient.findBaseUrl());
  }

  /**
   * Create Track
   * @description create a single track on PRS
   * @param apiBody ITrack object
   */
  async createTrack(apiBody: any): Promise<ITrack> {
    const path = '/prs/api/v1/track';
    return await this.post<any>(path, apiBody);
  }

  /**
   * Update Track
   * @description update a single track by ID on PRS
   * @param id Track ID
   * @param track ITrack object
   */
  async updateTrack(id: number, track: ITrack): Promise<ITrack> {
    const path = `/prs/api/v1/track/${id}`;
    return await this.put<any>(path, track);
  }

  /**
   * Delete Volume
   * @description Delete a volume and tracks into it
   * @param albumId Album ID
   * @param volumeNumber Volume number
   * @constructor
   */
  async DeleteVolume(albumId: string, volumeNumber: number): Promise<ITrack> {
    const path = `/prs/api/v1/track/${albumId}/${volumeNumber}/deleteVolume`;
    return await this.delete<any>(path);
  }

  /**
   * Create Tracks
   * @description create multiples tracks on PRS
   * @param apiBody Array of ITrack objects
   */
  async createTracks(apiBody: any): Promise<ITrack> {
    const path = '/prs/api/v1/tracks';
    return await this.post<any>(path, apiBody);
  }

  /**
   * Get Tracks
   * @description Get all the tracks from an Album
   * @param albumId Album ID
   */
  async getTracks(albumId: any): Promise<any> {
    const path = `/prs/api/v1/tracks`;
    return await this.get(path, albumId);
  }

  /**
   * Delete Track
   * @description Delete a single track by ID
   * @param tracksId Track ID
   */
  async DeleteTrack(tracksId: number): Promise<ITrack> {
    const path = '/prs/api/v1/tracks';
    const apiBody = JSON.stringify([tracksId]);
    return await this.delete<any>(path, apiBody);
  }

  /**
   * Delete Tracks
   * @description Delete multiples tracks
   * @param tracksIds Array of TrackIDs
   */
  async DeleteTracks(tracksIds: number[]): Promise<ITrack> {
    const path = '/prs/api/v1/tracks';
    const apiBody = JSON.stringify(tracksIds);
    return await this.delete<any>(path, apiBody);
  }

  /**
   * Lookup Tracks By ISRC
   * @description Look up tracks by ISRC in either Physical (PRS) or Digital (CMS) source
   * @param isrc ISRC to search for
   * @param source The source system to search ('physical' or 'digital')
   */
  async lookupTracksByIsrc(
    isrc: string,
    source: string = 'physical',
    labelId?: string
  ): Promise<ResponseModel<ITrackLookupResponse>> {
    const path = '/prs/api/v1/tracks/lookup';
    return await this.get<ResponseModel<ITrackLookupResponse>>(path, {
      isrc,
      source,
      labelId,
    });
  }
}

export const trackApiClient = new TrackApiClient();
